export default {
  getServicePrice(state) {
    return state.servicePrice;
  },
  getServicePricePayload(state) {
    return state.servicePricePayload;
  },
};
